// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pansear: PokeData = {
  "id": 513,
  "name": "pansear",
  "height": 6,
  "weight": 110,
  "base_experience": 63,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "scratch",
    "leer",
    "bite",
    "lick",
    "fire-blast",
    "amnesia",
    "fury-swipes",
    "crunch",
    "recycle",
    "yawn",
    "natural-gift",
    "fling",
    "flame-burst",
    "incinerate",
    "acrobatics",
    "play-nice"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "lick",
    "crunch",
    "acrobatics",
    "eruption",
    "sunny-day",
    "magma-storm",
    "blaze-kick",
    "morning-sun",
    "ember",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 263,
    "item": null,
    "species": [
      {
        "name": "pansear",
        "order": 514,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simisear",
        "order": 515,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 513,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49,
    "speed": 64,
    "ability_power": 53
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
